// Shared, price-independent curtain measurements. widthCm is TOTAL finished width.
export const positiveNumber = value => {
  const number = Number(String(value ?? "").replace(",", "."));
  return Number.isFinite(number) && number > 0 ? number : 0;
};
export const sheetNumber = value => Number(value).toLocaleString("tr-TR", { maximumFractionDigits: 2 });
export const isTulFonItem = item => item?.groupSlug === "tul_fon_perde" && !item.isAccessory && !item.isDikis && !item.isMotorRow;
export const hasTulFonItems = record => (record?.items || []).some(isTulFonItem);
export const kanatChoice = item => item.kanatSecimi || ({ "Tek Kanat": "tek", "İki Kanat": "iki", "Çift Kanat": "iki" }[item.kanatSayisi] || "");

export function tulFonMetraj(width, height, item = {}) {
  const w = positiveNumber(width), h = positiveNumber(height);
  const pile = positiveNumber(item.pileSikligi) || 2;
  const fabricWidth = positiveNumber(item.kumasEniCm) || 300;
  const lengths = Math.ceil(w * pile / fabricWidth);
  return { pile, fabricWidth, lengths, vertical: h > 300,
    mtul: h > 300 ? lengths * (h + 30) / 100 : w * pile / 100 };
}

export function curtainType(item) {
  if (item.curtainType) return item.curtainType;
  if (item.fabricGroup === "tf_fon" || item.fabricCategory === "fon") return "Fon";
  if (["tf_tul", "tf_havuz"].includes(item.fabricGroup) || item.fabricCategory === "tul") return "Tül";
  // A generic product name contains BOTH words; do not silently label it Fon.
  const name = String(item.product || "").toLocaleLowerCase("tr-TR");
  if (name.includes("fon") && !name.includes("tül") && !name.includes("tul")) return "Fon";
  if ((name.includes("tül") || name.includes("tul")) && !name.includes("fon")) return "Tül";
  return "Tül / Fon";
}

export function makeTailorItem(item, index) {
  const width = positiveNumber(item.widthCm), height = positiveNumber(item.heightCm);
  const qty = positiveNumber(item.qty) || 1;
  const measurement = tulFonMetraj(width, height, item);
  const choice = kanatChoice(item);
  const wings = choice === "iki" ? 2 : choice === "tek" ? 1 : null;
  const mount = item.tulMontaj || item.mounting || "Belirtilmedi";
  const motorName = item.motorLabel || (typeof item.motor === "string" && !["true", "false"].includes(item.motor) ? item.motor : "");
  const motorized = item.tulCalisma === "Motorlu" || (!item.tulCalisma && item.motor && item.motor !== "false");
  const operation = motorized ? ["Motorlu", motorName].filter(Boolean).join(" · ") : item.tulCalisma || "Kullanım belirtilmedi";
  const rows = [
    ["Kumaş", item.fabric || "Belirtilmedi"],
    ["Kod / Renk", [item.fabricCode, item.fabricColor].filter(Boolean).join(" · ") || "Belirtilmedi"],
    ["Pile", `${item.perdeStilit || "Stil belirtilmedi"} · 1:${sheetNumber(measurement.pile)}`],
    ["Astar", item.astarli ? ["Astarlı", item.astarKumas || "Kumaş belirtilmedi", item.astarFabricCode].filter(Boolean).join(" · ") : "Astarsız"],
    ["Montaj", `${mount} · ${operation}`],
    ["Ekstrafor", item.ekstrafor || "Belirtilmedi"],
    ["Etek", item.etek || "Belirtilmedi"],
    ...(item.dikisTuru ? [["Dikiş", item.dikisTuru]] : []),
    ...(item.desen ? [["Desen", item.desen]] : []),
    ...(item.note ? [["Terzi notu", item.note]] : []),
    ...(measurement.vertical ? [["Birleştirme", `${measurement.lengths} boy × ${sheetNumber(height + 30)} cm (30 cm pay dahil)`]] : []),
  ];
  return { ...measurement, raw: item, number: index + 1, width, height, qty, wings,
    room: String(item.roomName || "Oda belirtilmedi"), type: curtainType(item), rows,
    valid: Boolean(width && height), total: measurement.mtul * qty };
}

export function tailorWindowFabricRequirements(items) {
  // Each production item remains a separate window, even with the same room/fabric.
  return items.map(item => {
    const material = (kind, fabric, code, color) => ({
      kind, fabric: fabric || "Kumaş belirtilmedi", code, color,
      fabricWidth: item.fabricWidth, perWindowMtul: item.valid ? item.mtul : null,
      totalMtul: item.valid ? item.total : null,
    });
    return {
      number: item.number, room: item.room, type: item.type, qty: item.qty,
      materials: [
        material("Ana kumaş", item.raw.fabric, item.raw.fabricCode, item.raw.fabricColor),
        ...(item.raw.astarli ? [material("Astar", item.raw.astarKumas, item.raw.astarFabricCode, "")] : []),
      ],
    };
  });
}